<div class="wrapped-filter" (scroll)="onScroll($event)">
       <div class="container-filter" [class.expanded]="this.filterForm.searchViewOptions.expanded().value()">
        <search-filter-view-options [filterForm]="filterForm.searchViewOptions" [estateTypesForm]="filterForm.estateTypes"></search-filter-view-options>
    </div>
    <div class="container-filter" [class.expanded]="this.filterForm.estateTypes.expanded().value()">
        <search-filter-estate-types [filterForm]="filterForm.estateTypes"></search-filter-estate-types>
    </div>
    <div class="container-filter" [class.expanded]="this.filterForm.unitArea.expanded().value()">
        <search-filter-unitarea [filterForm]="filterForm.unitArea"></search-filter-unitarea>
    </div>
    <div class="container-filter" [class.expanded]="this.filterForm.timePeriod.expanded().value()">
        <search-filter-time-period [filterForm]="filterForm.timePeriod" [rangeToMonthListValue]="rangeToMonthListValue"></search-filter-time-period>
    </div>
    <div class="container-filter" [class.expanded]="this.filterForm.price.expanded().value()">
        <search-filter-price [filterForm]="filterForm.price"></search-filter-price>
    </div>
    <div class="container-filter" [class.expanded]="this.filterForm.buildYear.expanded().value()">
        <search-filter-buildyear [filterForm]="filterForm.buildYear"></search-filter-buildyear>
    </div>
    @if(hasGreenHousing()) {
    <div class="container-filter" [class.expanded]="this.filterForm.greenHousing.expanded().value()">
        <search-filter-green-housing [filterForm]="filterForm.greenHousing"></search-filter-green-housing>
    </div>
}
    <div class="container-filter" [class.expanded]="this.filterForm.energylabels.expanded().value()">
        <search-filter-energy-labels [filterForm]="filterForm.energylabels"></search-filter-energy-labels>
    </div>
    <div class="container-filter" [class.expanded]="this.filterForm.sqmPrice.expanded().value()">
        <search-filter-sqmprice [filterForm]="filterForm.sqmPrice"></search-filter-sqmprice>
    </div>
    <div class="container-filter" [class.expanded]="this.filterForm.timeOnMarket.expanded().value()">
        <search-filter-timeonmarket [filterForm]="filterForm.timeOnMarket"></search-filter-timeonmarket>
    </div>
    <div class="container-filter" [class.expanded]="this.filterForm.numberOfBedroom.expanded().value()">
        <search-filter-numberofbedroom [filterForm]="filterForm.numberOfBedroom"></search-filter-numberofbedroom>
    </div>
    <div class="container-filter" [class.expanded]="this.filterForm.floor.expanded().value()">
        <search-filter-floor [filterForm]="filterForm.floor"></search-filter-floor>
    </div>
    <div class="container-filter" [class.expanded]="this.filterForm.plotArea.expanded().value()">
        <search-filter-plotarea [filterForm]="filterForm.plotArea"></search-filter-plotarea>
    </div>
    <div class="container-filter" [class.expanded]="this.filterForm.ownershipTypes.expanded().value()">
        <search-filter-ownership [filterForm]="filterForm.ownershipTypes"></search-filter-ownership>
    </div>
    <div class="container-filter" [class.expanded]="this.filterForm.facilitiesTypes.expanded().value()">
        <search-filter-facilities [filterForm]="filterForm.facilitiesTypes"></search-filter-facilities>
    </div>
    <div class="container-filter" [class.expanded]="this.filterForm.siteTypes.expanded().value()">
        <search-filter-sitetype [filterForm]="filterForm.siteTypes"></search-filter-sitetype>
    </div>

</div>
